import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, exec } = useRequest({
    url: `/api/sealing/inspection/inferior`,
    name: 'SEALING_INSPECTION_UNQUALIFIED_POST',
    method: 'POST',
  });
  return [isRequestSuccessed, exec];
});
